import { CloudFile } from 'owa-attachment-file-types';
import {
    CreateSharingLinkFromFileProviderResult,
    GetODCSharingInfoResponse,
} from 'owa-fileprovider-link-services';
import AttachmentResultCode from 'owa-service/lib/contract/AttachmentResultCode';
import { getSharingLinkKindFromCreateSharingLinkFromFileProviderResult } from './getSharingLinkKindFromCreateSharingLinkFromFileProviderResult';

const UndefinedExpirationDate: string = '0001-01-01T00:00:00Z';
export function createGetODCSharingInfoResponse(
    file: CloudFile,
    createLinkResult: CreateSharingLinkFromFileProviderResult,
    linkId: string
): GetODCSharingInfoResponse {
    return {
        ResultCode: AttachmentResultCode.Success,
        FileName: file.name,
        MimeType: file.type,
        SharingLinkKind: getSharingLinkKindFromCreateSharingLinkFromFileProviderResult(
            createLinkResult,
            file.providerType
        ),
        BlocksDownload: false,
        CanShareExternally: true,
        CanCreateAnonymousEditLink: true,
        CanCreateAnonymousViewLink: true,
        ExpirationDate:
            createLinkResult.expirationDateTime === UndefinedExpirationDate
                ? null
                : createLinkResult.expirationDateTime,
        OriginalUrl: null,
        Type: createLinkResult.link.type,
        providerFileId: file.fileId,
        location: file.location,
    };
}
